import React, {Component} from 'react'
import {connect} from 'react-redux'
import Home from '../components/Home'
import {defaultState} from "../reducers/paginate";
import PropTypes from "prop-types";
import {setPageTitle} from "../components/utils";


class HomePage extends Component {

	componentWillMount() {
		setPageTitle();
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
	}

	render() {
		return (
			<div>
				<Home seasons={this.props.seasonsPage} />
			</div>
		)
	}
}

HomePage.propTypes = {
	seasonsPage: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {seasons},
	} = state;

	const seasonsPage = seasons[0] || defaultState;

	return {
		seasonsPage
	}
};

export default connect(mapStateToProps, {})(HomePage)


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/containers/HomePage.js